<template>
    <span>
        <font-awesome-icon
            v-if="!params.data.is_read && params.data.is_read !== undefined"
            size="lg"
            class="text-primary"
            :icon="['fas', 'circle-exclamation']"
            title="Unread"
        />
        <font-awesome-icon
            v-if="params.data.active"
            size="lg"
            class="text-primary"
            :icon="['fas', 'circle-check']"
            title="Push Notification Enabled"
        />
        <font-awesome-icon
            v-if="
                params.data.registration_id == this.currentToken() &&
                this.currentToken() !== null &&
                params.data.registration_id !== null
            "
            size="lg"
            class="text-secondary"
            :icon="['fas', 'circle-info']"
            title="Current Device"
        />
    </span>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        methods: {
            ...mapGetters('header', ['currentToken']),
        },
    };
</script>
